import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-comment-attachments',
  templateUrl: './comment-attachments.component.html',
  styleUrls: ['./comment-attachments.component.css']
})
export class CommentAttachmentsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
